import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "*",
    redirect: "/bjd",
  },
  {
    name: "home",
    component: () => import("./view/home"),
    meta: {
      title: "首页",
    },
  },
  {
    name: "video",
    component: () => import("./view/video/index"),
    meta: {
      title: "安装教程",
    },
  },
  {
    name: "videoList",
    path: "/video/list/:pId/:title",
    component: () => import("./view/video/list"),
    meta: {
      title: "安装教程",
    },
  },
  {
    name: "videoPreview",
    path: "/video/preview/:source",
    component: () => import("./view/video/preview"),
    meta: {
      title: "安装视频",
    },
  },
  {
    name: "player",
    component: () => import("./view/camera/player"),
    meta: {
      title: "实时监控",
    },
  },
  {
    name: "bjd",
    component: () => import("./view/bjd/index"),
    meta: {
      title: "森迈光电-灯光报价查询",
      keepAlive: true,
    },
  },
  {
    name: "bjd-result",
    component: () => import("./view/bjd/result"),
    meta: {
      title: "森迈光电-灯光报价单",
    },
  },
  {
    name: "protocol-user",
    component: () => import("./view/protocol/user-protocol.vue"),
    meta: {
      title: "服务协议",
    },
  },
  {
    name: "protocol-privacy",
    component: () => import("./view/protocol/privacy-protocol.vue"),
    meta: {
      title: "隐私政策",
    },
  },
  {
    name: "resList",
    path: "/resource/list/:pId/:title",
    component: () => import("./view/resource/list"),
    meta: {
      title: "资源列表",
    },
  },
  {
    name: "pdfPreview",
    path: "/resource/preview/:url",
    component: () => import("./view/resource/preview"),
    meta: {
      title: "PDF预览",
    },
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export { router };
